import React from 'react';
import Body from '../components/Body';
import GearCloset from '../components/travel/GearCloset';

export default function GearClosetPage() {
    return (
        <Body sidebar>
            <GearCloset />
        </Body>
    );
}
